import Echo from 'laravel-echo';

import { reverbConfig } from '@/config/reverb-config';

/** Webpack `browser` build usually exports the constructor; Node CJS uses `{ Pusher }`. */
function resolvePusherConstructor(
  m: unknown,
): new (...args: unknown[]) => unknown {
  if (typeof m === 'function') return m as new (...args: unknown[]) => unknown;
  if (m && typeof m === 'object') {
    const o = m as Record<string, unknown>;
    const fromDefault = o.default;
    const fromNamed = o.Pusher;
    if (typeof fromDefault === 'function') {
      return fromDefault as new (...args: unknown[]) => unknown;
    }
    if (typeof fromNamed === 'function') {
      return fromNamed as new (...args: unknown[]) => unknown;
    }
  }
  throw new Error(
    'pusher-js: could not resolve Pusher constructor (check webpack does not Babel-transpile pusher-js)',
  );
}

const PusherConstructor = resolvePusherConstructor(require('pusher-js'));

let echoSingleton: InstanceType<typeof Echo> | null = null;

export function getEcho(): InstanceType<typeof Echo> {
  if (!echoSingleton) {
    (window as unknown as { Pusher: typeof PusherConstructor }).Pusher =
      PusherConstructor;
    echoSingleton = new Echo({
      broadcaster: 'reverb',
      key: reverbConfig.key,
      wsHost: reverbConfig.wsHost,
      wsPort: reverbConfig.wsPort,
      wssPort: reverbConfig.wsPort,
      forceTLS: reverbConfig.scheme === 'https',
      enabledTransports: ['ws', 'wss'],
      disableStats: true,
    });
  }
  return echoSingleton;
}

export function disconnectEcho() {
  if (echoSingleton) {
    echoSingleton.disconnect();
    echoSingleton = null;
  }
}
